(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-save.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-save.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Button = svs.ui.ReactButton;
const MobileInput = svs.ui.reactFormInputs.MobileInput;
const _svs$myProfile$react$ = svs.myProfile.react.store.pdPreferences.actions,
  getCustomersPreferences = _svs$myProfile$react$.getCustomersPreferences,
  setForceSaveMobile = _svs$myProfile$react$.setForceSaveMobile;
const getMessageByCode = svs.myProfile.react.shared.errorMessages.getMessageByCode;
const saveCellPhone = svs.myProfile.react.store.pdPreferences.actions.saveCellPhone;
const Form = svs.ui.reactForm.Form;
const _svs$myProfile$react$2 = svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileDialogs,
  showSuccessDialog = _svs$myProfile$react$2.showSuccessDialog,
  showErrorDialog = _svs$myProfile$react$2.showErrorDialog;

const MobileSave = () => {
  const dispatch = ReactRedux.useDispatch();
  const history = useHistory();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences),
    cellphone = _ReactRedux$useSelect.cellphone;
  const isForceSave = ReactRedux.useSelector(state => state.playerPreferences.isForceSave);
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    phone = _useState2[0],
    setPhone = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    customFieldErrors = _useState4[0],
    setCustomFieldErrors = _useState4[1];
  const trackEventUpdate = saved => {
    const track = {
      category: 'My Profile',
      action: cellphone ? 'mobile add' : 'mobile update',
      opt_label: saved ? 'Yes' : 'No'
    };
    svs.components.analytics.trackEvent(track);
  };
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  const onSubmitHandler = async (e, formData, isValid) => {
    e.preventDefault();
    if (isValid) {
      if (phone === cellphone && !isForceSave) {
        setCustomFieldErrors({
          cellPhone: 'Ange ett nytt mobilnummmer'
        });
        return;
      }
      const result = await dispatch(saveCellPhone(phone));
      if (RTK.isFulfilled(result)) {
        trackEventUpdate(true);
        showSuccessDialog(phone, history);
        dispatch(setForceSaveMobile(false));
      } else {
        var _result$payload;
        const errorCode = result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.error;
        showErrorDialog(getMessageByCode(errorCode) || 'Någonting gick fel när telefonnumret skulle sparas. Försök igen eller kontakta kundservice.');
      }
    }
  };
  const handleOnChange = e => {
    let formattedNumber = e.target.value;
    if (formattedNumber.length > 2 && formattedNumber.slice(0, 2) === '46') {
      formattedNumber = "0".concat(formattedNumber.slice(2));
    }
    if (formattedNumber.length > 3 && formattedNumber.slice(0, 3) === '+46') {
      formattedNumber = "0".concat(formattedNumber.slice(3));
    }
    if (formattedNumber.length > 4 && formattedNumber.slice(0, 4) === '0046') {
      formattedNumber = "0".concat(formattedNumber.slice(4));
    }
    setCustomFieldErrors({});
    setPhone(formattedNumber);
  };
  return React.createElement(Form, {
    onSubmit: onSubmitHandler,
    setError: customFieldErrors
  }, React.createElement("div", {
    className: "f-left"
  }, React.createElement(MobileInput, {
    id: "mobileInput",
    isLessSpace: true,
    label: cellphone ? 'Ange nytt mobilnummer' : 'Ange mobilnummer',
    name: "cellPhone",
    onChange: handleOnChange,
    value: phone
  }), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    id: "mobileSubmit",
    inverted: true,
    size: 300,
    type: "submit"
  }, "Spara")));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileSave = MobileSave;

 })(window);